import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { AuthService } from "src/app/services/auth.service";
import { CursosService } from "src/app/services/cursos.service";
import * as jQuery from "jquery";
import { PerfilService } from "src/app/services/perfil.service";
import { EstudiosService } from "src/app/services/estudios.service";
import { ExperiencialaboralService } from "src/app/services/experiencialaboral.service";
import { PremiosService } from "src/app/services/premios.service";
import { environment } from "src/environments/environment";

import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import {
  AlertController,
  InfiniteScrollCustomEvent,
  NavController,
} from "@ionic/angular";
import {
  ActivatedRoute,
  Event,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from "@angular/router";
import { timeStamp } from "console";
import { ToastService } from "src/app/services/toast.service";
import { id } from "@swimlane/ngx-charts";

@Component({
  selector: "app-profesor",
  templateUrl: "./profesor.component.html",
  styleUrls: ["./profesor.component.scss"],
})
export class ProfesorComponent implements OnInit {
  @Input() public curso: any;
  @Input() public perfil: any;
  @Input() public data_profesores: any;

  argumentos;
  public searchControlProf: FormControl;

  textEditor: FormControl;
  searching: boolean;
  displayUserData: any;
  private ID: number;
  private AUTH_KEY: string;
  profesoresList: any = [];
  usersList: any = [];
  userData: any = [];
  edittext = false;
  tinyMCEConfiguration;
  descripcion: string = "";
  temp = "";
  page = 1;
  totalpages = 0;
  isModalOpen: any;
  selectedUser: any;
  profile: string;
  constructor(
    private sanitizer: DomSanitizer,
    private cursosService: CursosService,
    private authService: AuthService,
    private perfilService: PerfilService,
    public fb: FormBuilder,
    public alertController: AlertController,
    private activeRoute: ActivatedRoute,
    public toastService: ToastService
  ) {
    this.argumentos = this.activeRoute.snapshot.paramMap.get("id_curso");
    console.log("PROFESOR....");
    this.searchControlProf = new FormControl();
    this.searching = false;
    this.textEditor = this.fb.control("");

    this.tinyMCEConfiguration = {
      base_url: "/tinymce",
      suffix: ".min",
      plugins: "autoresize",
      max_height: 350,
    };

    // this.router.events.subscribe((event: Event) => {
    //   if (event instanceof NavigationStart) {
    //     console.log("event: ", event);
    //   }

    //   if (event instanceof NavigationEnd) {
    //     this.allDataUser([this.ID]).then((success) => {
    //       if (success) {
    //         this.myData = success[0];
    //         let descripcion: any = this.transform(success[0].descripcion);
    //         this.descripcion =
    //           descripcion.changingThisBreaksApplicationSecurity;
    //       }
    //     });
    //   }
    //   if (event instanceof NavigationError) {
    //     // Hide loading indicator

    //     // Present error to user
    //     console.log(event.error);
    //   }
    // });
  }
  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  loadUserData() {
    let promise = new Promise((resolve) => {
      this.authService.userData$.subscribe((res: any) => {
        console.log("🚀 ~ ProfesorComponent ~ loadUserData ~ res:", res)
        if (res) {
          if (!this.displayUserData) {
            this.displayUserData = res;
            this.ID = this.displayUserData?.id;
            this.AUTH_KEY = this.displayUserData?.auth_key;
            resolve(true);
          }
        }
      });
    });
    promise.then((success) => {
      /********promise********** */
      if (success) {
        this.profesores();
        let usersList = JSON.stringify(this.data_profesores);
        this.allDataUser([this.ID]).then((success) => {
          // if (success) {
          //   // this.myData = success[0];
          //   let descripcion: any = this.transform(success[0].descripcion);
          //   this.descripcion =
          //     descripcion.changingThisBreaksApplicationSecurity;
          //   // console.log("this.myData: ", this.myData);
          // }
        });
        if (JSON.parse(usersList).length > 0) {
          this.usersList = JSON.parse(usersList);

          let ids: any = [];
          this.data_profesores.forEach((element) => {
            ids.push(element.id);
          });
          this.allDataUser(ids).then((success) => {
            if (success) {
              this.userData = success;
            }
          });
        }
      }
      /********fin promise********** */
    });
  }
  getUserImage(imagenes, imgDefault = false) {
    let imagen: string = null;
    if (imgDefault) {
      imagen = "assets/imagenes/profesor.png";
    }
    if (imagenes) {
      if (imagenes.length > 0)
        imagenes.forEach((element) => {
          if (element.tipo == 2) {
            imagen = environment.host + "/" + element.url + element.name;
          }
        });
      return imagen;
    }
  }
  getUserBanner(imagenes) {
    let imagen: string = null;

    if (imagenes.length > 0)
      imagenes.forEach((element) => {
        if (element.tipo == 1) {
          imagen = element.url + element.name;
        }
      });
    return imagen;
  }
  allDataUser(ids = null): Promise<any> {
    return new Promise((resolve) => {
      if (ids == null || ids.length == 0) {
        resolve(false);
      } else {
        this.perfilService
          .getPerfilByIds(this.ID, this.AUTH_KEY, ids)
          .subscribe((res: any) => {
            let respuesta: any;
            respuesta = JSON.parse(res);
            if (respuesta.auth_key) {
              resolve(respuesta.data);
            } else {
              //logout
              resolve(false);
            }
          });
          this.cursosService._defaultProfile$.subscribe((lang) => {
            console.log("🚀 ~ ProfesorComponent ~ this.cursosService._defaultProfile$.subscribe ~ lang:", lang)
            this.profile = lang;
          });
      }
    });
  }
  ngOnInit() {
    this.loadUserData();
    this.searchControlProf.valueChanges.subscribe((search) => {
      this.searching = true;
      this.profesoresList = [];
      this.page = 1;
      this.profesores(search);
    });
  }
  profesores(params = "") {
    this.cursosService
      .getProfesores(this.ID, this.AUTH_KEY, params, this.curso.id, this.page)
      .subscribe((response) => {
        this.totalpages = response.totalPages;
        this.profesoresList.push(...response.result);
      });
  }

  onIonInfinite(event) {
    if (this.page == this.totalpages) {
      (event as InfiniteScrollCustomEvent).target.disabled = true;
    } else {
      this.page++;
      this.profesores();
      setTimeout(() => {
        (event as InfiniteScrollCustomEvent).target.complete();
      }, 500);
    }
  }

  checkProfesor(el) {
    let checkbox = jQuery(el.target);
    let id = jQuery(checkbox).data("id");

    let user = this.profesoresList.find((element) => element.id == id);
    let img = jQuery(checkbox).closest(".card-box").find(".img-chk");
    if (jQuery(checkbox).is(":checked")) {
      jQuery(img).addClass("active");
      this.usersList.push(user);
    } else {
      this.usersList.forEach((element, i) => {
        if (element.id == id) {
          this.usersList.splice(i, 1);
        }
      });
      jQuery(img).removeClass("active");
    }
  }
  isChekked(id) {
    let ischekked = false;
    let user = null;
    if (this.usersList.length > 0) {
      user = this.usersList.find((element) => element.id == id);
    }
    if (user != undefined) {
      ischekked = true;
    }

    return ischekked;
  }
  async presentAlertConfirm(message: string): Promise<boolean> {
    return new Promise(async (resolve) => {
      const alert = await this.alertController.create({
        cssClass: "my-custom-class",
        header: "Confirmar",
        message: message,
        buttons: [
          {
            text: "Cancelar",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
              resolve(false);
            },
          },
          {
            text: "Proceder",
            handler: () => {
              resolve(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }
  confirmarBtn(user) {
    this.presentAlertConfirm("¿Desea agregar este profesor al curso?").then(
      (res) => {
        if (res) {
          let params = {
            users_id: user.id,
            id_curso: this.curso.id,
          };
          this.cursosService
            .addEmailListProfesorCurso(this.ID, this.AUTH_KEY, params)
            .subscribe((response) => {
              this.toastService.presentToast("Se agregó el profesor al curso");
              setTimeout(() => {
                window.location.reload();
              }, 200);
            });
        }
      }
    );
  }

  trabajoActual(tactual) {
    let tarbajo_act = "ninguno";
    tactual.forEach((element) => {
      if (element.actual == 1) {
        tarbajo_act = element.empresa;
      }
    });
    return tarbajo_act;
  }

  editText() {
    this.edittext = !this.edittext;
  }

  editDescriptionUser() {
    if (!this.edittext) {
      this.temp = this.descripcion;
    }
    this.descripcion = this.temp;
    this.edittext = !this.edittext;
  }
  async saveDescriptionUser() {
    if (this.temp != this.descripcion) {
      // save
      let header = "¡Hecho!";
      let message = "Se registraron los datos";
      this.perfilService
        .createSobreMi(this.ID, this.AUTH_KEY, this.descripcion)
        .subscribe((res: any) => {
          console.log("RES: ", res);
          if (!res.error) {
            this.actionSaveDescription(header, message);
            this.edittext = false;
          } else {
            this.descripcion = this.temp;
            header = "¡ocurrió un error!";
            message = "Inténtelo más tarde";
            this.actionSaveDescription(header, message);
          }
        });
    }
  }
  async actionSaveDescription(header, message) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: header,
      message: message,
      buttons: [
        {
          text: "Aceptar",
          role: "cancel",
          cssClass: "secondary",
          handler: (res) => {},
        },
      ],
    });

    await alert.present();
  }

  detailUser(data: any) {
    this.isModalOpen = true;
    this.selectedUser = data;
  }
  unlinkUser(data: any) {
    this.presentAlertConfirm("¿Desea eliminar este profesor del curso?").then(
      (res) => {
        if (res) {
          let params = {
            auth_key: this.AUTH_KEY,
            id_user_curso: this.ID,
            id_user: data.id_user,
            id_curso: this.curso.id,
            tipo: "Profesor",
          };
          this.cursosService.unlikUserCurso(params).subscribe((response) => {
            this.toastService.presentToast("Se eliminó el profesor del curso");
            setTimeout(() => {
              window.location.reload();
            }, 200);
          });
        }
      }
    );
  }

  closeModal() {
    this.isModalOpen = false;
  }

  setOpen(isOpen: boolean) {
    this.isModalOpen = isOpen;
  }
}
